const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

const CACHE_POLICIES = [
  {
    name: "volatile",
    maxAge: 5 * MINUTE,
    pattern: /^(chats|notifications|reminds|daystaffs)(\/|$)/i,
  },
  {
    name: "operational",
    maxAge: DAY,
    pattern:
      /^(students|student|staffs|sections|sectionclasses|sectionclasselessons|parentfamilies|suppliers|schoolfees|reportcards|presences|leaves|schedules|notes|evaluations|expenses|wages|borrows)(\/|$)/i,
  },
  {
    name: "reference",
    maxAge: 7 * DAY,
    pattern:
      /^(years|year|years_|yearslist|yearslistetabli|months|days|countries|territories|communes|groupments|quartiers|classes|profiles|permissions|establishments|establishmentprofiles|categorystudents|reportcardcategories|lessons|domaines|authors|spots)(\/|$)/i,
  },
];

export const DEFAULT_CACHE_MAX_AGE = 6 * HOUR;
export const MAX_CACHED_RESPONSES_PER_USER = 500;

export const normalizeUrlPath = (url = "") => {
  try {
    return new URL(url, window.location.origin).pathname.replace(/^\/+/, "");
  } catch {
    return String(url).split("?")[0].replace(/^\/+/, "");
  }
};

export const getCachePolicy = (url) => {
  const path = normalizeUrlPath(url);
  return (
    CACHE_POLICIES.find((policy) => policy.pattern.test(path)) || {
      name: "default",
      maxAge: DEFAULT_CACHE_MAX_AGE,
    }
  );
};

export const stableSerialize = (value) => {
  if (value === null || typeof value !== "object") {
    return JSON.stringify(value);
  }

  if (Array.isArray(value)) {
    return `[${value.map(stableSerialize).join(",")}]`;
  }

  return `{${Object.keys(value)
    .sort()
    .map((key) => `${JSON.stringify(key)}:${stableSerialize(value[key])}`)
    .join(",")}}`;
};
